// Factory function pattern to avoid Webpack TDZ issues with class inheritance
// This uses BaseNotaryFactory instead of class inheritance

import { createBaseNotary, type IBaseNotary } from "../BaseNotaryFactory";
import type { CustomersInstance } from "./helpers/customersInstanceHelpers";
import { createCustomersInstance } from "./helpers/customersInstanceHelpers";
import { createApiFactory } from "@Front/Api/helpers/BaseApiFactoryGenerator";

const factory = createApiFactory<IBaseNotary, CustomersInstance>({
	name: "Customers",
	createBase: createBaseNotary,
	createInstance: createCustomersInstance,
});

export function getCustomersInstance(): CustomersInstance {
	return factory.getInstance();
}
